module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_14-77397a95756dec54324450ff9ce41fb4.png";